
  import Vue from 'vue'
  import ConnectorService from '@/services/ConnectorService';
  import EntityMetaDialog from '@/components/misc/EntityMetaDialog.vue';
  import { autoComplete, extractErrorMessage } from '@/utils/Util';
  import AlertsListDialog from '@/components/entities/alert/AlertsListDialog.vue';
  import PropertyInfoDialog from '@/components/entities/property/PropertyInfoDialog.vue';
  import NotesListDialog from '@/components/entities/note/NotesListDialog.vue';

  export default Vue.extend({
    name: 'ConnectorInfoDialog',

    components: {
        EntityMetaDialog,
        AlertsListDialog,
        NotesListDialog,
        PropertyInfoDialog,
        // Weird import necessary due to circular dependency
        DeviceInfoDialog: () => import('@/components/entities/device/DeviceInfoDialog.vue') as any
    },
    props: ['connector', 'tenant'],
    data: () => ({
        localdialog: false,
        valid: true,
        alertText: "",
        alertVisible: false,
        alertType: "error",
        loading: false,
        loadingProperty: false,
        associatedDeviceFilter: "",
        associatedDevices: [] as any[],
        associatedTags: [] as any[],
        associatedAlerts: [] as any[],
        associatedNotes: [] as any[],
        associatedProperty: null as any,
    }),
    methods: {
      close() {
        this.localdialog = false;
      },
      clear() {
        this.associatedDevices = [];
        this.alertVisible = false;
        this.associatedTags = [];
        this.associatedAlerts = [];
        this.associatedNotes = [];
        this.associatedProperty = null;
        this.loading = false;
        this.loadingProperty = false;
        this.associatedDeviceFilter = "";
      },
      dismiss() {
        this.clear();
        this.close();
      },
      getAssociatedDevices() {
        this.loading = true;

        ConnectorService.getAssociatedDevices(this.currentTenant, this.connector.uuid).then((devices: any[]) => {
            this.loading = false;
            this.associatedDevices = devices;
            if(devices.length === 0) {
                this.alertType = "warning";
                this.alertText = this.$t('connector.emptyAssociatedDevice') as string;
                this.alertVisible = true;
            }
        }).catch((err) => {
            console.log(err);
            console.log(err.response);
            this.alertType = "error";
            this.alertText = this.$t('connector.errorAssociatedDevice') + ' ' + extractErrorMessage(err);
            this.alertVisible = true; 
            this.loading = false;
        });
      },
      getAssociatedTags() {
        this.loading = true;

        ConnectorService.getAssociatedTags(this.currentTenant, this.connector.uuid).then((tags: any[]) => {
            this.associatedTags = [];
            this.loading = false;
            this.associatedTags = tags;
        }).catch((err) => {
            console.log(err);
            console.log(err.response);
            this.alertType = "error";
            this.alertText = this.$t('property.errorAssociatedDevice') + ' ' + extractErrorMessage(err);
            this.alertVisible = true; 
            this.loading = false;
        });
      },
      getAssociatedProperty() {
        this.loadingProperty = true;

        ConnectorService.getAssociatedProperty(this.currentTenant, this.connector.uuid).then((property: any) => {
            this.associatedProperty = property;
            this.loadingProperty = false;
        }).catch((err) => {
            console.log(err);
            console.log(err.response);
            this.loadingProperty = false;
        });
      },
      getAssociatedAlerts() {
        this.loading = true;

        ConnectorService.getAssociatedAlerts(this.currentTenant, this.connector.uuid).then((alerts: any[]) => {
            this.associatedAlerts = alerts;
            this.loading = false;
        }).catch((err) => {
            console.log(err);
            console.log(err.response);
            this.alertType = "error";
            this.alertText = this.$t('alert.loadingError') + ' ' + extractErrorMessage(err);
            this.alertVisible = true;
            this.loading = false;
        });
      },
      getAssociatedNotes() {
        ConnectorService.getNotes(this.currentTenant, this.connector.uuid).then((notes: any[]) => {
            this.associatedNotes = notes;
        }).catch((err: any) => {
            console.log(err, err.response);
        });
      },
      openAssociatedDevices() {
          this.$router.push({ name: 'Devices', params: { connector: this.connector } });
      },
      autoComplete,
    },
    watch: {
        async localdialog(value: boolean) {
            if(value) {
                this.getAssociatedDevices();
                this.getAssociatedTags();
                this.getAssociatedAlerts();
                this.getAssociatedNotes();
                this.getAssociatedProperty();
            } else {
                this.clear();
            }
        }
    },
    computed: {
        filteredAssociatedDevices(): any[] {
            return this.associatedDevices.filter((value: any) => this.autoComplete(value, this.associatedDeviceFilter));
        },
        currentTenant(): any {
            if(this.tenant)
                return this.tenant.uuid;

            return this.$root.$store.state.session.selectedTenant.uuid;
        }
    }
  })
